import React, { useEffect, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../../components/notification";
import {
  PaginationDetails,
  PaginationDetailsDummyData,
} from "../../interface/api_request";
import RequestContent from "../../components/request/RequestContent";
import { apiGetAllRequest } from "../../api/requests";

const Requests: React.FC = () => {
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const [request_list, setRequest_list] = useState<any[]>([]);

  // set up pagination state
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData,
  );
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        request_mutation.mutate();
      } catch (error) {
        console.error("Error in sequential calls:", error);
      }
    };
    fetchData();
  }, [pagination_state?.page, refresh]);

  const handleRefresh = () => setRefresh(!refresh);
  const request_mutation = useMutation({
    mutationFn: () => apiGetAllRequest(),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        if (!!data?.data?.meta) {
          setPagination_state({
            hasNextPage: data?.data?.meta?.hasNextPage,
            hasPrevPage: data?.data?.meta?.hasPrevPage,
            nextPage: data?.data?.meta?.nextPage,
            page: data?.data?.meta?.page,
            pages: data?.data?.meta?.pages,
            prevPage: data?.data?.meta?.prevPage,
            reads: data?.data?.meta?.reads,
            totalDocs: data?.data?.meta?.totalDocs,
            unReads: data?.data?.meta?.unReads,
          });
        }
        if (data?.data?.data?.length > 0) {
          setRequest_list(data.data.data);
        } else {
          setRequest_list([]);
        }
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Employee Requests
            </Typography>
          </Stack>
        </Box>
      </Header>
      <RequestContent
        handleRefresh={handleRefresh}
        request_list={request_list}
        loading={request_mutation.isPending}
      />
    </>
  );
};

export default Requests;
